import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounceTime, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-catalog-inline-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
    @Input() mobile = false;
    @Input() keyword = '';
    @Input() placeholder = 'default.filterByTitle';
    @Output() handleSearch: EventEmitter<string> = new EventEmitter();
    @Output() handleAiSearch: EventEmitter<string> = new EventEmitter();

    private inputChange$ = new Subject<string>();
    private destroy$ = new Subject<void>();
    private lastEmittedKeyword = '';
    private lastEmitTime = 0;
    private readonly THROTTLE_MS = 2000;
    private isFocused = false;

    constructor() { }

    ngOnInit(): void {
        this.inputChange$
            .pipe(
                debounceTime(this.THROTTLE_MS),
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                if (this.isFocused) {
                    this.tryEmitAiSearch();
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onChange(value: string) {
        this.keyword = value;
        this.handleSearch.emit(this.keyword);
        this.inputChange$.next(this.keyword);
    }

    onFocus() {
        this.isFocused = true;
    }

    onBlur() {
        this.isFocused = false;
        this.tryEmitAiSearch();
    }

    onEnter() {
        this.tryEmitAiSearch();
    }

    private tryEmitAiSearch() {
        const now = Date.now();
        const trimmed = this.keyword.trim();
        if (!trimmed) return; // non-empty only
        if (trimmed === this.lastEmittedKeyword) return; // must be changed
        if (now - this.lastEmitTime < this.THROTTLE_MS) return; // throttle 5s window

        this.lastEmittedKeyword = trimmed;
        this.lastEmitTime = now;
        this.handleAiSearch.emit(trimmed);
    }
}
